import { useRef, useEffect } from 'react';

import type { FC, ReactNode, TransitionEventHandler } from 'react';

import styles from './styles/index.module.scss';

type Props = {
  open: boolean,
  children: ReactNode,
};

const SlideToggle: FC<Props> = ({ open, children }) => {
  const wrap = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const scrollHeight = wrap.current.scrollHeight;
    if (open) {
      wrap.current.style.height = `${scrollHeight}px`;
    } else {
      wrap.current.style.height = `${scrollHeight}px`;
      wrap.current.offsetHeight;
      wrap.current.style.height = '0';
    }
  }, [open]);

  const handleTransitionEnd: TransitionEventHandler = () => {
    if (open) {
      wrap.current.style.height = 'auto';
    }
  };

  return (
    <div className={styles.wrap} ref={wrap} style={{ height: 0 }} onTransitionEnd={handleTransitionEnd}>
      {children}
    </div>
  )
};

export default SlideToggle;